import React from 'react';
import Head from 'next/head';
import styles from './StaticPage.module.css';
import {safeHtml} from '@helper/sanitize-html';

function StaticPage({ content = {} }) {

    return (
        <>
            {/* SEO Meta Tags */}
            <Head>
                <title>{content.meta_title || content.static_title || 'TNH Hospital'}</title>
                {content.meta_description && (
                    <meta name="description" content={content.meta_description} />
                )}
                {content.meta_keywords && (
                    <meta name="keywords" content={content.meta_keywords} />
                )}
            </Head>

            <div className={styles.staticPageWrapper}>
                <div className={styles.container}>
                    {/* Tiêu đề */}
                    <h1 className={styles.title}>{content.static_title}</h1>

                    {/* Nội dung */}
                    <div
                        className={styles.content}
                        dangerouslySetInnerHTML={safeHtml(content.static_content)}
                    />
                </div>
            </div>
        </>
    );
}

export default StaticPage;
